import { MD5 } from 'crypto-js';

import { isLocal } from '../../../helpers';
import trans from '../../../helpers/trans';
import { FetchResult, FetchResultType } from '../../FetchResult/FetchResult';

export const meilisearchFetch = async <ResponseData>(
    endpoint: string,
    options?: RequestInit,
): Promise<FetchResult<ResponseData, string>> => {
    let data: ResponseData | null;

    // Redis configuration
    const optionsString = options ? JSON.stringify(options) : '';
    const cacheKey = `meili_${MD5(endpoint + optionsString)}`;
    let hasRedisConnection = true;

    try {
        // Return stored data from Redis if it exists
        if (!isLocal) {
            const redisResponse = await fetch(`/redis/${cacheKey}`);
            const redisData = await redisResponse.text();

            hasRedisConnection = redisResponse.ok;

            if (redisResponse.ok && redisData) {
                data = JSON.parse(redisData);

                return {
                    status: 200,
                    type: FetchResultType.Success,
                    data: data as ResponseData,
                };
            }
        }

        const apiUrl = process.env.REACT_APP_MEILISEARCH_HOST_URL || '';
        const apiSecret = process.env.REACT_APP_MEILISEARCH_API_KEY || '';

        const response = await fetch(apiUrl + endpoint, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Accept-Language': 'nl',
                Authorization: `Bearer ${apiSecret}`,
                ...options?.headers,
            },
        });

        data = await response.json();

        // Store response in Redis, to prevent excessive Meilisearch calls from other clients
        if (!isLocal && hasRedisConnection) {
            await fetch(`/redis/${cacheKey}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({ data }),
            });
        }

        return {
            status: 200,
            type: FetchResultType.Success,
            data: data as ResponseData,
        };
    } catch (error: unknown) {
        console.error('[meilisearchFetch]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    } finally {
        data = null;
    }
};
